import { activitySchemaProcessed } from '@eventr/common'
import { zodResolver } from '@hookform/resolvers/zod'
import { useEffect } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { useParams } from 'react-router-dom'
import { z } from 'zod'
import {
    editHeaderTranslation,
    editItineraryFieldsTranslation,
    editItineraryTranslation,
    generalTranslation,
} from '../../../i18n/translateHelpers'
import { FormDateTime } from '../formComponents/formDateTime'
import { FormEditMembers } from '../formComponents/formEditMembers'
import { FormText } from '../formComponents/formText'
import { PremiumFormUploadDocs } from '../formComponents/formUploadDocs'
import { SectionEdit } from '../formComponents/section'
import { useEditItem } from '../hooks/useEditItem'
import { BaseEditItem } from '../subPages/baseEditItem'
import { DateFieldsValidator } from './dateFieldValidator'
import { TaskList } from './taskList'
export function todoSchema() {
    return activitySchemaProcessed
}
export type TodoValidationSchema = z.infer<ReturnType<typeof todoSchema>>
export const TodoEditPage = () => {
    const { idItem } = useParams<{
        idItem: string
    }>()
    // get new from url params
    const newItem = new URLSearchParams(window.location.search).get('new')
    const isNew = newItem === 'true'
    const item = useEditItem(8, idItem!)

    const methods = useForm<TodoValidationSchema>({
        resolver: zodResolver(todoSchema()),
        shouldFocusError: true,
        resetOptions: {
            keepDirty: false,
            keepDirtyValues: false,
            keepValues: false,
        },
    })
    const {
        control,
        reset,
        watch,
        formState: { isDirty },
    } = methods
    useEffect(() => {
        reset(item, {
            keepDirty: false,
            keepValues: false,
            keepDirtyValues: false,
            keepTouched: false,
            keepIsSubmitted: false,
            keepIsValid: false,
            keepSubmitCount: false,
            keepErrors: false,
        })
    }, [item, reset])
    const name = watch('todo_name')

    return (
        <FormProvider {...methods}>
            <BaseEditItem
                saveAllowed={isDirty}
                isNewItem={isNew}
                deleteButtonText={editItineraryTranslation('Delete To Do List')}
                headerText={
                    isNew
                        ? editItineraryTranslation('New To Do List')
                        : generalTranslation('Edit') + ' ' + name
                }
            >
                <DateFieldsValidator />
                <SectionEdit
                    headerIcon="Itinerary"
                    headerText={editHeaderTranslation('To Do Details')}
                />
                <FormText
                    required
                    fieldLabel={editItineraryFieldsTranslation(
                        'To Do List Name'
                    )}
                    control={control as any}
                    name="todo_name"
                />
                <FormText
                    fieldLabel={editItineraryFieldsTranslation('Description')}
                    control={control as any}
                    name="todo_description"
                    multiline
                    rows={2}
                />
                <FormDateTime
                    fieldLabel={editItineraryFieldsTranslation('Due Date')}
                    control={control}
                    name="due_date"
                />
                <FormDateTime
                    fieldLabel={editItineraryFieldsTranslation('Start By')}
                    control={control}
                    name="start_by"
                />
                <SectionEdit
                    headerIcon="ToDo"
                    headerText={editHeaderTranslation('Tasks')}
                />
                <TaskList />
                <SectionEdit
                    headerIcon="Additional_Information"
                    headerText={editHeaderTranslation('Additional information')}
                />
                <FormText
                    fieldLabel={editItineraryFieldsTranslation(
                        'Additional information'
                    )}
                    control={control as any}
                    name="attendees_list.0.notes"
                    multiline
                    rows={2}
                />
                <PremiumFormUploadDocs
                    fieldLabel={editItineraryFieldsTranslation('Documents')}
                    control={control}
                    name={`attendees_list.0.documents`}
                />
                <SectionEdit
                    headerIcon="Add_User"
                    headerText={editHeaderTranslation('Assign Users')}
                />
                <FormEditMembers
                    control={control}
                    name="attendees_list.0.users"
                />
            </BaseEditItem>
        </FormProvider>
    )
}
